import pages from "./zh-HK/pages";
import tip from "@/locales/zh-HK/tip";
export default {
  "batch.add.tips": "成功{success}条，失败{error}条",
  ...pages,
  ...tip,
};
